import { fetcher } from "helpers/fetcher";

import { TAddStaffInsuranceReq, TAddStaffInsuranceRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const addStaffInsurance = async (payload: TAddStaffInsuranceReq) => {
  return await fetcher<TAddStaffInsuranceRes, TAddStaffInsuranceReq["data"]>(
    ENDPOINT.USER.ADD_STAFF_INSURANCE,
    {
      data: payload.data,
      headers: {
        [API_HEADER.USER_ID]: payload.idUser,
        [API_HEADER.VERSION]: ENDPOINT.USER.ADD_STAFF_INSURANCE.version,
      },
    }
  );
};

export const mutationAddStaffInsurance = async (
  payload: TAddStaffInsuranceReq
) => {
  return (await addStaffInsurance(payload)).data.message;
};

mutationAddStaffInsurance._key = (payload: TAddStaffInsuranceReq) => [
  ENDPOINT.USER.ADD_STAFF_INSURANCE.url,
  payload,
];
